/**
 * @generated SignedSource<<29291c86e80d0530a7d95f3b3a300046>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
import { FragmentRefs } from "relay-runtime";
export type WidgetFileStatic_widgetFile$data = {
  readonly files: ReadonlyArray<{
    readonly file: {
      readonly id: string;
      readonly name: string | null;
      readonly status: FileStatus;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetFilePageProcessing_file">;
    };
    readonly pages: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetFilePage_page">;
    }>;
  }>;
  readonly id: string;
  readonly slideshowDuration: number | null;
  readonly title: string;
  readonly " $fragmentType": "WidgetFileStatic_widgetFile";
};
export type WidgetFileStatic_widgetFile$key = {
  readonly " $data"?: WidgetFileStatic_widgetFile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFileStatic_widgetFile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetFileStatic_widgetFile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slideshowDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetFileEdge",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilePage",
          "kind": "LinkedField",
          "name": "pages",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetFilePage_page"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "file",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetFilePageProcessing_file"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetFile",
  "abstractKey": null
};
})();

(node as any).hash = "9ac02b418551eb36341b6e8d316ca1ed";

export default node;
